module.exports = __webpack_public_path__ + "img/4.6168ba5d.jpg";